import { Map, List } from "immutable";
import { CaseRecordsPipeline } from "utilities";

import {
    // USER_ACTIONS,
    CASE_TYPES,
    STATE_STATUS,
    CASE_ACTIONS,
    STAGE_ACTIONS,
    STAGE_CASE_ACTIONS,
    BUCKET_LIST_ACTIONS
} from "constants";

const INTIAL_STATE = CASE_TYPES.mapEntries(([K]) => {
    return [K, new Map({})];
});

export default (state = INTIAL_STATE, { type, payload }) => {
    switch (type) {
    // case USER_ACTIONS.FETCHED_USER:
    //         return state.set("INBOX", payload.)
    case STAGE_ACTIONS.FETCHED_STAGES_LIST:
        return state.map((_, k) => {
            return new List(payload.stageList)
                .toMap()
                .mapEntries(([, V]) => {
                    return [
                        V.stage_name,
                        new Map({
                            data:
                                    k === "INBOX" ? new Map({}) : new List([]),
                            status: STATE_STATUS.UNFETCHED
                        })
                    ];
                })
                .set("status", STATE_STATUS.UNFETCHED);
        });
    case CASE_ACTIONS.FETCH_CASES:
        return state.setIn(
            [payload.caseStatus, "status"],
            STATE_STATUS.FETCHING
        );
    case CASE_ACTIONS.FETCHED_CASES:
        return state
            .set(
                payload.caseStatus,
                payload.cases.map(_ => CaseRecordsPipeline.run(new List(_)))
            )
            .set("status", STATE_STATUS.FETCHED);

    case CASE_ACTIONS.FAILED_FETCH_CASES:
        return state.setIn(
            [payload.caseStatus, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case BUCKET_LIST_ACTIONS.FETCH_CASE_BUCKET_LIST:
        return state.setIn(
            ["INBOX", payload.stage, payload.type, "status"],
            STATE_STATUS.FETCHING
        );
    case STAGE_CASE_ACTIONS.FETCH_STAGE_CASE:
        return state.setIn(
            ["INBOX", payload.stage, "status"],
            STATE_STATUS.FETCHING
        );
    case BUCKET_LIST_ACTIONS.FETCHED_CASE_BUCKET_LIST:
        return state
            .setIn(
                ["INBOX", payload.stage, payload.stage_type, "data", payload.page],
                CaseRecordsPipeline.run(new List(payload.cases))
            )
            .setIn(
                ["INBOX", payload.stage, payload.stage_type, "status"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                ["INBOX", payload.stage, payload.stage_type, "count"],
                payload.count
            );
    case STAGE_CASE_ACTIONS.FETCHED_STAGE_CASE:
        return state
            .setIn(
                ["INBOX", payload.stage, "data", payload.page],
                CaseRecordsPipeline.run(new List(payload.cases))
            )
            .setIn(
                ["INBOX", payload.stage, "status"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                ["INBOX", payload.stage, "count"],
                payload.count
            );
    case STAGE_CASE_ACTIONS.FAILED_FETCH_STAGE_CASE:
    case BUCKET_LIST_ACTIONS.FAILED_FETCH_BUCKET_LIST:
        return state.setIn(
            [payload.caseStatus, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case STAGE_CASE_ACTIONS.RESET_STAGE_CASE:
        return state
            .setIn([payload.type, payload.stageName, "data"], new List([]))
            .setIn(
                [payload.type, payload.stageName, "status"],
                STATE_STATUS.UNFETCHED
            );

    case "LOGOUT":
        return INTIAL_STATE;
    default:
        return state;
    }
};
